
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { CommonContext } from "../../../App";
import CancelButton from "../Button/CancelButton";
import SaveButton from "../Button/SaveButton";
import { useTranslation } from "react-i18next";
import api from "../../../services/api";

const AddUnit = ({ onClose, onAreaSaved, onUnitAdded, selectedArea,onUpdate }) => {
    const [formData, setFormData] = useState({ name: "" });
    const [loading, setLoading] = useState(false);
    const { branchId } = useContext(CommonContext);
    const { t } = useTranslation();

    // 🟢 Prefill data if editing
    useEffect(() => {
        if (selectedArea) {
            setFormData({
                name: selectedArea.name || "",
            });
        }
    }, [selectedArea]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        if (!formData.name) {
            toast.error("Please fill in both fields");
            return;
        }

        try {
            setLoading(true);

            let res;
            if (selectedArea) {
                // 🟠 Update area
                res = await api.put(`unit/update/${selectedArea.id}`, {
                    name: formData.name,
                    branchId
                });
            } else {
                // 🟢 Create area
                res = await api.post(`unit/create`, {
                    branchId,
                    name: formData.name
                });
            }

            if (res.status === 200 || res.status === 201 || res.statusText === "OK" || res.statusText === "Created") {
                toast.success(
                    selectedArea ? "Unit updated successfully" : "Unit added successfully"
                );
                onUpdate()

                const newArea =
                    res.data?.data || {
                        id: res.data?.id,
                        name: formData.name
                    };

          
                if (selectedArea && typeof onAreaSaved === "function") {
                    onAreaSaved(); // Refresh area table
                } else if (!selectedArea && typeof onUnitAdded === "function") {
                    const createdArea =
                        res.data?.data || 
                        res.data || 
                        {
                            id: res.data?.id,
                            name: formData.name,
                        };

                    // console.log("✅ Passing new area to parent:", createdArea);
                    onUnitAdded(createdArea);
                } else if (typeof onAreaSaved === "function") {
                    onAreaSaved(); 
                }

                onClose();
            } else {
                toast.error(res.data?.message || "Failed to save unit");
            }
        } catch (err) {
            console.error("Error saving area:", err);
            toast.error("error while saving area");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-2 w-96">
                <div className=" font-semibold mb-2 text-center bg-theme-bg text-theme-color bg-theme-headerBg p-1 rounded-1">
                    {selectedArea ? t("editUnit") : t("addNewUnit")}
                </div>

                <div className="mb-3">
                    <label className="block text-sm font-medium mb-1">{t("unitName")}</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full border px-2 py-1 rounded outline-none"
                        placeholder="Unit Name"
                    />
                </div>
                <div className="flex justify-end gap-2">
                    <CancelButton onClick={onClose} text={t("cancel")} disabled={loading} />
                    <SaveButton
                        onClick={handleSave}
                        text={
                            loading
                                ? t("processing")
                                : selectedArea
                                    ? t("update")
                                    : t("save")
                        }
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddUnit;
